import {Component} from 'substance'

class UnsupportedBlockNodeComponent extends Component {
    render($$) {
        var node = this.props.node;
        var el = $$('div')
            .addClass('dw-unsupported-block-node')
            .attr('data-id', node.id)

        el.append(`Unsupported object <${node.tagType}>`)
        return el
    }
}

export {UnsupportedBlockNodeComponent}
